module.exports = __webpack_public_path__ + "img/circle-rolling.0d6ff72c.svg";